import ProfilePage from "./ProfilePage";
import PeriodFinancesPage from "./PeriodFinancesPage";

const UserPages = {
    Profile: ProfilePage,
    PeriodFinances: PeriodFinancesPage,
}

export default UserPages